(function () {
	'use strict';

	angular.module('documentCompareWithEarlierVersionModule', [])
		.controller('DocumentCompareWithEarlierVersionController', controller);

	controller.$inject = ['$http', '$state', '$sce', '$scope', '$q', 'documentService', 'configService'];

	function controller($http, $state, $sce, $scope, $q, documentService, configService) {
        var vm = this;
        
        vm.translation = globalResources
		vm.DocumentTitleResult = '';
        vm.currentDocumentId = $state.params.documentId;
        vm.childDocumentId = $state.params.documentId;
        vm.parentDocumentId = 0;
		vm.originalData = {};
		vm.fromVersions = [];
		vm.toVersions = [];
		vm.input = {
			fromVersion: null,
			toVersion: null
		};
		vm.documentCKVersion = CkVersion.CK4;
		vm.ckVersion = { 'CK4': CkVersion.CK4, 'CK5': CkVersion.CK5 };
		vm.advancedCompare = configService.getBool(HandbookConfiguration.AdvancedCompare);
		vm.enableDocumentExtention = configService.getBool(HandbookConfiguration.EnableDocumentExtention);
        vm.showCompareParentExtension = false;
        vm.showCompareChildrenExtension = false;

		initialize();
		vm.printDocumentComparison = printDocumentComparison;
		vm.changeFromVersion = changeFromVersion;
        vm.changeToVersion = changeToVersion;
        vm.viewCompareParentDocument = viewCompareParentDocument;
        vm.viewCompareChildDocument = viewCompareChildDocument;


        function initialize() {

			window.addEventListener('resize', initCompareScrollEvent, true /*Capture event*/);
			angular.element('.main-container_header').hide();

            $scope.$on('$destroy', function () {
                window.removeEventListener('resize', initCompareScrollEvent);
            });

            function initCompareScrollEvent() {
                if (vm.advancedCompare) {
                    angular.element('.comparison-result').removeAttr('style');
                    angular.element('#resizeBar').removeAttr('style');
                    angular.element('.comparison-versions').removeAttr('style');
                }
            }
            
            if (vm.enableDocumentExtention) {
                vm.parentDocumentId = 0;

                var promises = [];

                promises.push(documentService.getParentIdExtendDocument(vm.currentDocumentId));
                promises.push(documentService.checkDocumentHaveToCompareById(vm.currentDocumentId));

                $q.all(promises).then(function (result) {
                    var resultGetParentId = parseInt(result[0]);
                    if (resultGetParentId && resultGetParentId > 0) {
                        vm.parentDocumentId = resultGetParentId;
					}

					var resultCheckDocumentHaveToCompareById = result[1];
                    if (!resultCheckDocumentHaveToCompareById) {
                        vm.currentDocumentId = vm.parentDocumentId;
                    }

                    vm.showCompareParentExtension = vm.parentDocumentId > 0;
                    vm.showCompareChildrenExtension = resultCheckDocumentHaveToCompareById;

                    generateComparisonResult(null, 0);
                });
            }
            else {
                generateComparisonResult(null, 0);
            }
		}

		function generateComparisonResult(selectedVersion, isType) {

			var params = {
				params: {
                    documentId: vm.currentDocumentId,
					fromVersion: vm.input.fromVersion,
					toVersion: vm.input.toVersion
				}
			};

			$http
				.get('/api/Documents/GenerateDocumentComparisonResult', params)
				.success(function (data) {
					vm.data = data;
					if (vm.advancedCompare) {
						if (isType == 0) { // initialize
							vm.originalData = angular.copy(vm.data);
							getDataForComboVersions(selectedVersion, isType);
							vm.input.fromVersion = parseInt(data.earlierVersionNumber);
							vm.input.toVersion = parseInt(data.latestVersionNumber);
						} else {
							getDataForComboVersions(selectedVersion, isType);
						}
					}
					vm.documentCKVersion = data.isNewCKVersion;
					vm.DocumentTitleResult = $sce.trustAsHtml(String.format('{0} - {1} - {2}: {3} - {4} {5} {6} {7}', globalResources.ComparisonResult,
                        data.comparisonNameResult, globalResources.DocId, vm.currentDocumentId,
						globalResources.CommonGridColumns.Version, data.earlierVersionNumber, globalResources.And, data.latestVersionNumber));
					vm.data.earlierVersionHtml = $sce.trustAsHtml(data.earlierVersionHtml);
					vm.data.latestVersionHtml = $sce.trustAsHtml(data.latestVersionHtml);
					vm.data.comparisonResult = $sce.trustAsHtml(data.comparisonResult);
				})
				.error(function (data, status, headers, config) {
					vm.errorMessage = getErrorMessage(status);
				});
		}

		function getDataForComboVersions(selectedVersion, isType) {

			if (selectedVersion == null && isType > 0)
				return;
			var latestVersion = parseInt(vm.originalData.latestVersionNumber);
			var fromVersions = [];
			var toVersions = [];
			switch (isType) {
				case 0:// initialize
					selectedVersion = latestVersion - 1;
					for (var i = 0; i <= selectedVersion; i++) {
						fromVersions.push({ id: i, name: i });
					}
					for (var j = selectedVersion + 1; j <= latestVersion; j++) {
						toVersions.push({ id: j, name: j });
					}
					vm.fromVersions = angular.copy(fromVersions);
					vm.toVersions = angular.copy(toVersions);
					break;
				case 1: // From version
					for (var j = selectedVersion + 1; j <= latestVersion; j++) {
						toVersions.push({ id: j, name: j });
					}
					vm.toVersions = angular.copy(toVersions);
					break;
				case 2: // to version
					selectedVersion = selectedVersion - 1;
					for (var i = 0; i <= selectedVersion; i++) {
						fromVersions.push({ id: i, name: i });
					}
					vm.fromVersions = angular.copy(fromVersions);
					break;
				default:
			}
		}

		function changeFromVersion() {
			generateComparisonResult(vm.input.fromVersion, 1);
		}

		function changeToVersion() {
			generateComparisonResult(vm.input.toVersion, 2);
		}

		function printDocumentComparison() {
			if (vm.advancedCompare) {
				window.open(String.format('/Printing/PrintDocumentComparisonResultForLatestApproved?documentId={0}&fromVersion={1}&toVersion={2}', vm.currentDocumentId, vm.input.fromVersion, vm.input.toVersion));
			} else {
                window.open(String.format('/Printing/PrintDocumentComparisonResultForLatestApproved?documentId={0}', vm.currentDocumentId));
			}
        }

        function viewCompareParentDocument() {
            if (vm.currentDocumentId != vm.parentDocumentId) {
                vm.currentDocumentId = vm.parentDocumentId;
                vm.input.fromVersion = null;
                vm.input.toVersion = null;
                generateComparisonResult(null, 0);
            }
        }

        function viewCompareChildDocument() {
            if (vm.currentDocumentId != vm.childDocumentId) {
                vm.currentDocumentId = vm.childDocumentId;
                vm.input.fromVersion = null;
                vm.input.toVersion = null;
                generateComparisonResult(null, 0);
            }
        }
	}
})();